import { api } from '../../../api/api';
const eventApi = api.getEventApi();
export class GlobalGuideApiImpl {
    constructor() {
        this.name = 'globalGuideApiImpl';
        this.http = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    async get(url, req, config) {
        var _a, _b;
        try {
            const { data } = await this.http.get(url, req, config);
            if (!data || !data.success) {
                return Promise.reject(data === null || data === void 0 ? void 0 : data.message);
            }
            return data === null || data === void 0 ? void 0 : data.data;
        }
        catch (err) {
            eventApi.sendSysEvent({
                eventSeq: 0,
                eventName: 'error',
                eventLevel: 'error',
                eventData: {
                    title: ((_a = err.data) === null || _a === void 0 ? void 0 : _a.message) || ((_b = err.data) === null || _b === void 0 ? void 0 : _b.msg) || '网络错误',
                    popupType: 'toast',
                    popupLevel: 'error',
                    content: '',
                },
                auto: true,
            });
            return Promise.reject(err.data);
        }
    }
    async post(url, body, config) {
        var _a, _b;
        const apiConfig = Object.assign({ contentType: 'json', noEnqueue: false }, (config || {}));
        try {
            const { data } = await this.http.post(url, body, apiConfig);
            if (!data || !data.success) {
                return Promise.reject(data === null || data === void 0 ? void 0 : data.message);
            }
            return data === null || data === void 0 ? void 0 : data.data;
        }
        catch (err) {
            eventApi.sendSysEvent({
                eventSeq: 0,
                eventName: 'error',
                eventLevel: 'error',
                eventData: {
                    title: ((_a = err.data) === null || _a === void 0 ? void 0 : _a.message) || ((_b = err.data) === null || _b === void 0 ? void 0 : _b.msg) || '网络错误',
                    popupType: 'toast',
                    popupLevel: 'error',
                    content: '',
                },
                auto: true,
            });
            return Promise.reject(err.data);
        }
    }
    async getGuideContent(moduleType) {
        return this.get(this.systemApi.getUrl('getGuideContent'), { moduleType });
    }
    getAppVersion(req) {
        return this.get(this.systemApi.getUrl('getAppUpgradeVersion'), req);
    }
}
GlobalGuideApiImpl.RndSyncRate = Math.floor(6 * Math.random());
const globalGuideApiImpl = new GlobalGuideApiImpl();
api.registerLogicalApi(globalGuideApiImpl);
export default globalGuideApiImpl;
